import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-943eb462")

_pushScopeId("data-v-943eb462")
const _hoisted_1 = { class: "ExpressMultiItemsForm" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "ExpressMultiItemsForm__title" }, "Добавление товаров", -1)
const _hoisted_3 = { class: "ExpressMultiItemsForm__form" }
const _hoisted_4 = { class: "ExpressMultiItemsForm__actions" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Добавить товар ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_s_input, {
        disabled: _ctx.disabled,
        placeholder: "Наименование товара",
        value: _ctx.state.title,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.title = $event)),
        "is-invalid": _ctx.v$.title.$error
      }, null, 8, ["disabled", "value", "is-invalid"]),
      _createVNode(_component_s_input, {
        disabled: _ctx.disabled,
        placeholder: "Цена товара",
        value: _ctx.state.price,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.price = $event)),
        "is-invalid": _ctx.v$.price.$error
      }, null, 8, ["disabled", "value", "is-invalid"]),
      _createVNode(_component_s_input, {
        disabled: _ctx.disabled,
        placeholder: "Количество",
        value: _ctx.state.count,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.count = $event)),
        "is-invalid": _ctx.v$.count.$error
      }, null, 8, ["disabled", "value", "is-invalid"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_s_button, {
        class: "blue",
        disabled: _ctx.disabled,
        onClick: _ctx.emitAddItem
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
})